import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'proforma-request-type-config.form-empty-state.title',
		defaultMessage: 'Forms',
		description: 'Proforma RTC empty state title.',
	},
	subtitle: {
		id: 'proforma-request-type-config.form-empty-state.subtitle',
		defaultMessage: 'Search and select an existing form to add to this request type.',
		description: 'Proforma RTC empty state subtitle.',
	},
	searchAndCreateFormDescription: {
		id: 'proforma-request-type-config.form-empty-state.search-and-create-form-description',
		defaultMessage:
			'Attach an existing form to this request type, or create a new form using a template.',
		description:
			'Description in empty state panel to tell users to search for existing forms or create a new template form using a template',
	},
	createFormDescription: {
		id: 'proforma-request-type-config.form-empty-state.create-form-description',
		defaultMessage:
			'Search the form template library to create a form to attach to this request type.',
		description:
			'Description in empty state panel to tell users to create a new template form from using template',
	},
	addFormButton: {
		id: 'proforma-request-type-config.form-empty-state.add-form-button',
		defaultMessage: 'Add form',
		description: 'Proforma RTC empty state add form button.',
	},
	formsNotLoadedError: {
		id: 'proforma-request-type-config.form-empty-state.forms-not-loaded-error',
		defaultMessage: 'We’re unable to load existing forms. Refresh this page and try again.',
		description: 'Error message when proforma forms do not load',
	},
	attachFormButton: {
		id: 'proforma-request-type-config.form-empty-state.attach-form-button',
		defaultMessage: 'Attach form',
		description:
			'Proforma RTC empty state, button to start attaching form (either from an existing form or a new form)',
	},
	selectExistingFormButton: {
		id: 'proforma-request-type-config.form-empty-state.select-existing-form-button',
		defaultMessage: 'Select existing',
		description: 'Proforma RTC empty state, button to select an existing form in the project',
	},
	createFromTemplateButton: {
		id: 'proforma-request-type-config.form-empty-state.create-from-template-button',
		defaultMessage: 'Create from template',
		description: 'Proforma RTC empty state, button to create a new form from the template library',
	},
});

export default messages;
